import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'td-wb-joyride-button',
  templateUrl: './joyride-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class JoyrideButtonComponent {
  @Input() buttonId: string;
  @Output() clicked: EventEmitter<void> = new EventEmitter();

  onClick(): void {
    this.clicked.emit();
  }
}
